<template>
  <div>
    <div class="bg-box">
      <span v-html="$t('joinUs')"></span>
    </div>

    <div class="content-container">

      <div class="top-box">
        <span class="top-title">{{$t('introduceCom')}}</span>
        <span class="desc-text">{{$t('introduceOne')}}</span>
        <div class="top-img-box">
          <img src="../assets/introduce_1.png"/>
          <img src="../assets/introduce_2.png" />
        </div>
      </div>

      <div class="center-box">
        <span class="center-title">{{$t('ourTeam')}}</span>
        <span class="desc-text">{{$t('introduceTwo')}}</span>
        <div class="center-img-box">
          <img src="../assets/introduce_3.png" />
          <img src="../assets/introduce_4.png" />
          <img src="../assets/introduce_5.png" />
        </div>
      </div>

      <div class="bottom-box">
        <div class="bottom-text-box">
          <span class="center-title">{{$t('ourCulture')}}</span>
          <span class="desc-text">{{$t('introduceThree')}}</span>
        </div>
        <img src="../assets/introduce_6.png" />
      </div>

    </div>

    <fix-footer />
  </div>
</template>

<script>
import Footer from '@/components/Footer';

export default {
  
  components: {
    'fix-footer': Footer,
  }
}
</script>

<style lang="less" scoped>

.bg-box{
  background: url('../assets/introduce_bg.png') no-repeat center center;
  background-size: 100% 100%;
  height: 340px;/*px*/
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  padding: 40px 0;
  box-sizing: border-box;

  span{
    color: #fff;
    font-size: 50px; /*px*/
    line-height:60px;
  }
}

.content-container{
  padding: 50px 360px;
}

.desc-text{
  color: #000;
  font-size: 35px; /*px*/
  line-height:1.5;
  margin-bottom: 25px;
  word-break:normal; 
  width:auto; 
  display:block; 
  white-space:pre-wrap;
  word-wrap : break-word ;
  overflow: hidden ;
  text-align: justify;
}
.center-title{
  color: #061E34;
  font-size: 35px; /*px*/
  margin: 30px 0;
  font-family:PingFangSC-Medium,PingFang SC;
  font-weight:500;
}


.top-box{
  display: flex;
  flex-direction: column;
  text-align: left;

  .top-title{
    color: #061E34;
    font-size: 42px; /*px*/
    margin-bottom: 40px;
    font-family:PingFangSC-Medium,PingFang SC;
    font-weight:500;
    text-align: center;
  }

  .top-img-box{
    display: flex;
    flex-direction: row;
    justify-content: space-between;

    img{
      width: 530px;
      height: 325px;
      padding: 10px;
    }
  }
}

.center-box{
  padding: 50px 0;
  display: flex;
  flex-direction: column;
  text-align: left;

  .center-img-box{
    display: flex;
    flex-direction: row;
    justify-content: space-between;

    img{
      width: 350px;
      height: 250px;
      padding: 10px;
    }

  }
}

.bottom-box{
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  // width: 100%;
  padding: 20px 0;
  overflow: hidden;

  .bottom-text-box{
    display: flex;
    flex-direction: column;
    text-align: left;
    padding-right: 50px;
    width: 50%;
    // overflow: hidden;
  }

  img{
    // display: block;
    width: 567px;
    height: 449px;
  }
}

</style>


// WEBPACK FOOTER //
// src/pages/Introduce.vue